export enum FormSubmitEnum {
  SUBMIT_AND_CONTINUE = 'submit-and-continue',
  SUBMIT_AND_SAVE = 'submit-and-save',

  SUBMITTER_FIELD = 'submitter',
}
